export default __webpack_public_path__ + "static/media/bag-2.acb45d6c.png";